/**
 * usuariosRouter.
 *
 * Permite el control completo de rootPath y enrutado de un subconcepto de enrutamiento general.
 *
 * @author Daniel Lepe
 * @date 20 de Abril, 2023
 * @version 1.0
 */

const rootPath = '/usuarios', // Ruta completa del módulo
    rootName = 'Usuarios - ',
    indexName = 'Lista completa', indexURL = 'index';

const router = {
    path: rootPath,
    redirect: rootPath + '/' + indexURL,
    component: () => import('@/containers/DefaultContainer'),
    children: [
        {
            path: indexURL,
            name: rootName + indexName,
            component: () => import('@/modules' + rootPath + '/index.vue'),
            meta: {}
        }
    ]
}

// EASYLUNCH
const nav = {
    name: 'Usuarios',
    icon: 'fa fa-user',
    url: rootPath + '/' + indexURL,
    // children: [
    //     {
    //         name: indexName,
    //         url: rootPath + '/' + indexURL
    //     }
    // ]
}

export {
    rootPath,
    indexName,
    router,
    nav
}
